interface MetaData {
  title: string;
  description: string;
}

interface MetaDataConfig {
  [key: string]: MetaData;
}

export const metadataConfig: MetaDataConfig = {
  default: {
    title: 'solvpath - Intelligent CS Automation',
    description:
      'solvpath offers automated customer support solutions, empowering you to take control of your post-sale strategy. Enhance retention, deflect cancellations, and reduce refunds for a stronger bottom line.',
  },
  booking: {
    title: 'Book a Meeting | Solvpath Partnership',
    description: 'Schedule a meeting with our team to learn more about Solvpath Partnership',
  },
  ftc: {
    title: 'FTC click to cancel compliance',
    description: 'FTC click to cancel compliance',
  },
};
